export default __webpack_public_path__ + "static/media/soundtrack.14a6a92a.mp3";